import React from 'react';
import { Dropdown } from 'antd';
import { I18n } from '@aws-amplify/core';
import { EllipsisOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';

import { MoreActionsButton } from '@/components/views/BeraJob/Results/ActionPlans/ActionPlanCard/styles';

interface MoreActionsProps {
	menuItems?: MenuProps['items'];
	onClick: () => void;
}

export function MoreActions({ menuItems, onClick }: Readonly<MoreActionsProps>): JSX.Element {
	const icon = <EllipsisOutlined style={{ fontSize: 16, color: '#262626' }} />;

	if (!menuItems) {
		return <MoreActionsButton onClick={onClick}>{icon}</MoreActionsButton>;
	}

	return (
		<Dropdown menu={{ items: menuItems }} trigger={['click']}>
			<MoreActionsButton type="button" aria-label={I18n.get('Actions')}>
				{icon}
			</MoreActionsButton>
		</Dropdown>
	);
}
